module.exports = __webpack_public_path__ + "img/block_3.c1072953.webp";